import { fetchQbrDocument } from './fetchQbrDocument'
import { fetchQBRDocumentPartners } from './fetchQBRDocumentPartners'

interface IFetchQbrMainData {
  documentId: number
}

export const fetchQbrMainData = async ({ documentId }: IFetchQbrMainData) => {
  const qbrDocument = await fetchQbrDocument({ documentId })
  if (qbrDocument) {
    const partners = await fetchQBRDocumentPartners({
      entryId: documentId,
      partnerIds: qbrDocument.PartnerIDs,
      fYear: qbrDocument.FYear,
      settings: qbrDocument.Settings,
      rtm: qbrDocument.RTM,
    })

    return {
      qbrDocument,
      partners,
    }
  }
  return null
}
